/**Custom slider start**/
if ($(".hero-slides .hero-slide").length > 1) {
  (function () {
    var rotate, timeline, rotates, mobilerotate;
    rotate = function () {
      return $(".hero-slide:first-child")
        .addClass("swing")
        .fadeOut(900, "swing", function () {
          return $(".hero-slide:first-child")
            .hide()
            .appendTo(".hero-slides")
            .removeClass("swing");
        })
        .fadeIn(900, "swing");
    };
    mobilerotate = function () {
      return $(".hero-slide:first-child")
        .addClass("swing")
        .fadeOut(900, "linear", function () {
          return $(".hero-slide:first-child")
            .hide()
            .appendTo(".hero-slides")
            .removeClass("swing");
        })
        .fadeIn(600, "linear");
    };
    rotates = function (classname) {
      return $(".hero-slide:first-child")
        .addClass("swing")
        .fadeOut(900, "swing", function () {
          $(".hero-slide:first-child")
            .hide()
            .appendTo(".hero-slides")
            .removeClass("swing");
          return $(".hero-slide").prependTo(".hero-slides");
        })
        .fadeIn(900, "swing");
    };

    var newWindowWidth = $(window).width();
    if (newWindowWidth <= 768) {
      $(".hero-slide ").swipe(function (e, touch) {
        return mobilerotate();
      });
    } else {
      $(".hero-slide").click(function () {
        $(".dot").removeClass("is-selected");
        $(".dot").removeAttr("aria-current");
        var classn = $(this).next().data("id");
        //console.log(classn);
        $('.dot[data-id="' + classn + '"]')
          .addClass("is-selected")
          .attr("aria-current", "step");
        return rotate();
      });
      $(".next").click(function () {
        $(".hero-slide:first-child").click();
      });
    }
    $(".dot").on("click", function () {
      $(".dot").removeClass("is-selected");
      $(".dot").removeAttr("aria-current");
      var classname = $(this).data("id");
      //console.log(classname);
      $('.dot[data-id="' + classname + '"]')
        .addClass("is-selected")
        .attr("aria-current", "step");
      //var classIndex = classname;
      if ($(".hero-slide:first-child").data("id") != classname) {
        return rotates(classname);
      }
    });
  }.call(this));
}
$(".hero-slider").css("height", $(".hero-slide .text").height());
var matched = $(".hero-slides .hero-slide");
var number = matched.length;
//   alert(number);
if (number == 1) {
  $(".navigation-button").hide();
}

/**Custom slider end**/
